/*
* Project: LegalPlace assistant
* File: src/redux/reducers/loading.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import {
  WIZARD_LOAD,
  WIZARD_UNLOAD,
  PRICE_LOAD,
  PRICE_UNLOAD,
  IS_CHECKING,
  IS_CHECKING_PAYMENT,
} from '../actions/loading';

export function loadingDetails(state = {
  wizard: false,
  pricing: false,
  checking: false,
  checking_payment: false,
}, action) {
  const result = Object.assign({}, state);
  switch (action.type) {
    case WIZARD_LOAD:
      result.wizard = true;
      break;
    case WIZARD_UNLOAD:
      result.wizard = false;
      break;
    case PRICE_LOAD:
      result.pricing = true;
      break;
    case PRICE_UNLOAD:
      result.pricing = false;
      break;
    case IS_CHECKING:
      result.checking = action.is_checking;
      break;
    case IS_CHECKING_PAYMENT:
      result.checking_payment = action.is_checking;
      break;
    default:
      break;
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/loading.js